import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecruiterDataService, Job } from '../../services/recruiter-data.service';
import { CompanyOnboardingService } from '@edtech-ui/hiring-workspace/services/company-onboarding.service';
import { CompanyRecentJob } from '@edtech-ui/core/models/onBord-company/company-dashboard';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
	selector: 'app-tab-dashboard',
	standalone: true,
	imports: [CommonModule, MatProgressSpinnerModule],
	templateUrl: './tab-dashboard.component.html',
	styleUrls: ['./tab-dashboard.component.scss']
})
export class TabDashboardComponent implements OnInit {

	stats: any = {
		totalJobs: 0,
		activeJobs: 0,
		applicationsReceived: 0,
		interviewsCompleted: 0,
		assessmentsConducted: 0,
		shortlistedCandidates: 0
	};
	isLoading = false;

	dashboardData: any;
	companyId!: string;

	recentJobs: CompanyRecentJob[] = [];
	recentApplications: any[] = [];

	constructor(
		private companyService: CompanyOnboardingService,
		private toastr: ToastrService
	) { }

	ngOnInit(): void {
		this.companyId = localStorage.getItem('company_id') || '';
		if (this.companyId) {
			this.getCompanyDashboardStats();
		}
	}

	getCompanyDashboardStats(): void {
		if (!this.companyId) return;

		this.isLoading = true;

		this.companyService.getCompanyDashboardStats(this.companyId).pipe(
			finalize(() => {
				this.isLoading = false;
			})
		).subscribe({
			next: (response) => {
				if (response.Success) {
					this.dashboardData = response.Data;
					this.stats = {
						totalJobs: response.Data?.total_jobs_posted?.count || 0,
						activeJobs: response.Data?.active_jobs?.count || 0,
						applicationsReceived: response.Data?.applications_received?.count || 0,
						interviewsCompleted: response.Data?.interviews_completed?.count || 0,
						assessmentsConducted: response.Data?.assessments_conducted?.count || 0,
						shortlistedCandidates: response.Data?.shortlisted_candidates?.count || 0
					};
					this.recentJobs = response.Data.recent_jobs;
				} else {
					this.toastr.error(response.Message);
				}
			},
			error: (error) => {
				this.toastr.error('Failed to load dashboard data');
			}
		});
	}


}